module.exports = __webpack_public_path__ + "static/music-circle2.008405a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/music-circle2.jpg
// module id = 354
// module chunks = 35783957827783